import React from 'react'
import WidgetSelector from './WidgetSelector'

export default function WidgetEmployeeSelector({
  value,
  displayValue,
  employees,
  onChange,
  viewOnly,
  reloadDropdownData,
  size,
}) {
  return (
    <React.Fragment>
      <WidgetSelector
        viewOnly={viewOnly || false}
        selectedValue={value}
        displayValue={displayValue}
        options={employees}
        onChange={(values) => onChange(values)}
        reloadDropdownData={() => reloadDropdownData()}
        placeHolder="Select Employee"
        showCloudIcon={true}
        size={size}
      />
    </React.Fragment>
  )
}
